export { default } from './DNSMissingTXT';
